import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # CommonCd
 *
 * 공통코드 모델
 */
export const CommonCd = types
  .model('CommonCd')
  // --------------------------------------------------------------------------
  .props({
    code: types.maybeNull(types.number),
    pcode: types.maybeNull(types.number),
    value: types.maybeNull(types.string),
    eValue: types.maybeNull(types.string),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model commonCd --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as ICommonCd;
      (Object.keys(newProps) as TCommonCdKeys[]).forEach((key) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TCommonCd = Instance<typeof CommonCd>;
type TCommonCdSnapshot = SnapshotOut<typeof CommonCd>;

export interface ICommonCd extends TCommonCd {}
export type TCommonCdKeys = keyof TCommonCdSnapshot & string;
export interface ICommonCdSnapshot extends TCommonCdSnapshot {}
export const createCommonCd = () => types.optional(CommonCd, {} as TCommonCd);

/**
 * # CodeGroupModel
 * - name별 그룹화된 공통코드 모델
 */
export const CodeGroupModel = types.model('CodeGroupModel', {
  name: types.string,
  list: types.array(CommonCd),
});
type TCodeGroupModel = Instance<typeof CodeGroupModel>;
type TCodeGroupModelSnapshot = SnapshotOut<typeof CodeGroupModel>;
export interface ICodeGroupModel extends TCodeGroupModel {}
export type TCodeGroupModelKeys = keyof TCodeGroupModelSnapshot & string;
export interface ICodeGroupModelSnapshot extends TCodeGroupModelSnapshot {}
